import { createAsyncThunk } from "@reduxjs/toolkit";
import { type FirstPurchaseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const unnotifyBenefit = createAsyncThunk<
  void,
  string,
  { dispatch: FirstPurchaseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UNNOTIFY_BENEFIT, async (requestId, { extra }) => {
  await extra.firstPurchaseRepo.unnotifyBenefit(requestId);
});
